import type { CommercialBillingCycle } from "@itaas/pep-contracts";

export const BILLING_CYCLE_OPTIONS: Array<{
  id: CommercialBillingCycle;
  label: string;
  desc: string;
  badge?: string;
}> = [
  {
    id: "monthly",
    label: "Mensuel",
    desc: "Facturation chaque mois — flexibilité maximale.",
    badge: "Standard",
  },
  {
    id: "quarterly",
    label: "Trimestriel",
    desc: "Facturation tous les 3 mois — prévisibilité budgétaire.",
  },
  {
    id: "annual",
    label: "Annuel",
    desc: "Facturation une fois par an — engagement long terme.",
  },
];

export function billingCycleLabel(cycle: CommercialBillingCycle): string {
  return BILLING_CYCLE_OPTIONS.find((o) => o.id === cycle)?.label ?? cycle;
}
